import _ from 'lodash';
import {NewInstallationGroupItemActionTypes as actionTypes } from './NewInstallationGroupItemActions';

const initialState = {
  overlayVisible: false,
  group: "",
  edit: {}
};

export default function newInstallationGroupReducer(state = initialState, action) {
  var newState = {...state};
  switch(action.type) {
    case actionTypes.SHOW_OVERLAY:
      newState.overlayVisible = action.payload.show;
      newState.group = action.payload.group;
      newState.edit = action.payload.data;
    break;
  }

  return newState;
}